<a
    class="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-white focus:px-4 focus:py-2 focus:shadow"
    href="#main-content"
>
    Zum Inhalt springen
</a>

@defer (on immediate) {
    <app-nav-wrapper [showHighlightBanner]="showHighlightBanner()" />
}

<div class="outer-wrapper">
    <header>
        @if (showHighlightBanner()) {
            <ui-m040-c150-highlight-banner [dealer]="dealer()" />
        }
        <app-nav-bar />
        @if (showImprintNotice()) {
            <ui-m040-c005-imprint-notice [dealer]="dealer()" />
        }
    </header>
    <main id="main-content">
        <router-outlet />
    </main>

    @defer (on immediate) {
        <app-footer-pw />
    }
</div>
